import React from 'react'
import './BuildVersion.css'

interface BuildVersionProps {
  className?: string
}

const BuildVersion: React.FC<BuildVersionProps> = ({ className = '' }) => {
  // Generate build version from current timestamp and package version
  const buildVersion = `v${import.meta.env.npm_package_version || '1.0.0'}-${new Date().toISOString().slice(0, 10).replace(/-/g, '')}`
  const buildTime = new Date().toLocaleString('ja-JP', { 
    year: 'numeric', 
    month: '2-digit', 
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  })

  return (
    <div className={`build-version ${className}`}>
      <div className="build-info">
        <span className="version-text">{buildVersion}</span>
        <span className="build-time">Built: {buildTime}</span>
      </div>
    </div>
  )
}

export default BuildVersion